import intl from "react-intl-universal";
import React, { useState, useEffect, useMemo } from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { Image, Button, Tabs, Pagination, Spin, Masonry } from "antd";
import profile from "@/assets/images/profile.png";
import { userCollectList, userShareList } from "@/apis/discover";
import { useSelector, useDispatch } from "react-redux";
import { setIsOpen } from "@/store/modules/user";
import SVG from "react-inlinesvg";
import UserList from "./userList";
import { infoByUuid, followStats, isFollowByMe, updateFllow, userDataStatistics } from "@/apis/user";
import { useSearchParams } from "react-router-dom";
import { userOverview } from "@/apis/statistics";
import ResourceCard from "@/components/ResourceCard";
import NoData from "@/components/NoData";

import {
	HeartFilled,
} from "@ant-design/icons";

const sorts = [
	{
		title: "按最后修改时间",
		value: "updateTime"
	}, {
		title: "按浏览次数",
		value: "views"
	}, {
		title: "按收藏次数",
		value: "collects"
	}, {
		title: "按下载次数",
		value: "downloads"
	}
]
const User = () => {
	const { userInfo } = useSelector((state) => state.user);
	const token = useMemo(() => userInfo?.token, [userInfo]);
	const dispatch = useDispatch()
	const [dataSource, setDataSource] = useState([]);
	const [tabKey, setTabKey] = useState('1');
	const [total, setTotal] = useState(0);
	const [params, setparams] = useState({
		currentPage: 1,
		pageSize: 10,
	});
	const [loading, setLoading] = useState(false);
	let [searchParams] = useSearchParams();
	const [baseInfo, setBaseInfo] = useState({});
	const [hotInfo, setHotInfo] = useState({});
	const [starts, setStarts] = useState({});
	const [dataInfo, setDataInfo] = useState({})
	const [sortBy, setSortBy] = useState("updateTime");
	const [isFollow, setIsFollow] = useState(false);
	const uuid = searchParams.get('uuid');
	const pUuid = localStorage.getItem('uuid');
	const items = [
		{
			key: '1',
			label: `${intl.get("User.Share")}（${dataInfo.contributionCount || 0}）`,
			children: "",
		}, {
			key: '2',
			label: `${intl.get("User.Collected")}（${dataInfo.favoriteCount || 0}）`,
			children: "",
		}, {
			key: '3',
			label: `${intl.get("User.Followers")}（${starts.followerCount || 0}）`,
			children: <UserList pUuid={pUuid} tabKey={tabKey} type="1" uuid={uuid} pageParam={params} setTotal={setTotal} />,
		}, {
			key: '4',
			label: `${intl.get("User.Following")}（${starts.followingCount || 0}）`,
			children: <UserList pUuid={pUuid} tabKey={tabKey} type="2" uuid={uuid} pageParam={params} setTotal={setTotal} />,
		}
	]

	useEffect(() => {
		if (uuid) {
			infoByUuid({
				userUuid: uuid
			}).then(res => {
				setBaseInfo(res.data)
			})
			followStats({
				userUuid: uuid
			}).then(res => {
				setStarts(res.data)
			})
			userOverview({
				userUuid: uuid
			}).then(res => {
				setHotInfo(res.data)
			})
			userDataStatistics({
				userUuid: uuid
			}).then(res => {
				setDataInfo(res.data)
			})
		}
	}, [uuid])

	useEffect(() => {
		if (uuid && token) {
			isFollowByMe(uuid).then(res => {
				setIsFollow(res.data.following)
			})
		}
	}, [uuid, token])

	const getCollectList = () => {
		setLoading(true);
		userCollectList({
			pageParam: params,
			sortParam: {
				sortBy: sortBy,
				desc: true
			},
			userUuid: uuid,
		}).then(res => {
			setLoading(false);
			setDataSource(res.data?.records || []);
			setTotal(res.data?.total || 0)
		})
	}

	const getShareList = () => {
		setLoading(true);
		userShareList({
			pageParam: params,
			sortParam: {
				sortBy: sortBy,
				desc: true
			},
			userUuid: uuid,
		}).then(res => {
			setLoading(false);
			setDataSource(res.data?.records || []);
			setTotal(res.data?.total || 0)
		}).catch(err => {
			setLoading(false);
		})
	}
	useEffect(() => {
		if (uuid && (tabKey === "1" || tabKey === "2")) {
			if (tabKey === "1") {
				getShareList()
			} else if (tabKey === "2") {
				getCollectList()
			}
		}
	}, [params, tabKey, uuid, sortBy, token]);

	const changeSort = (type) => {
		setparams({
			...params,
			currentPage: 1,
		})
		setSortBy(type)
	}

	const updateData = (id, flag) => {
		setDataSource(dataSource.map(item => {
			if (item.resourceUuid === id) {
				return {
					...item,
					isFavorite: flag,
					collectTimes: flag ? item.collectTimes + 1 : item.collectTimes - 1
				}
			} else {
				return item
			}
		}))
	}

	const handelFollow = () => {
		if (token) {
			updateFllow(uuid, isFollow ? "delete" : "get").then(res => {
				setIsFollow(!isFollow);
			})
		} else {
			dispatch(setIsOpen(true));
		}
	}

	return <div className={styles.userBox}>
		<div className={classNames("container")}>
			<div className={classNames(styles.topBox, "flex_box flex_between")}>
				<div className={classNames("flex_box", styles.leftBox)}>
					<Image
						className={styles.profile}
						alt="basic"
						src={baseInfo.avatarFilePath ? process.env.REACT_APP_API_AFFIX + "/file/preview?filePath=" + baseInfo.avatarFilePath : profile}
					/>
					<div className={styles.infoBox}>
						<div className={styles.name}>
							{baseInfo.nickname}
						</div>
						<div className={classNames(styles.statistics, "flex_box")}>
							<div>
								<span>{hotInfo.SumViewTimes || 0}</span>
								<i>{intl.get("Total Visits")}</i>
							</div>
							<div>
								<span>{hotInfo.SumCollectTimes || 0}</span>
								<i>{intl.get("Favorited")}</i>
							</div>
							<div>
								<span>{hotInfo.SumCommentTimes || 0}</span>
								<i>{intl.get("comments")}</i>
							</div>
							<div>
								<span>{starts.followerCount}</span>
								<i>{intl.get("User.Followers")}</i>
							</div>
							<div>
								<span>{starts.followingCount}</span>
								<i>{intl.get("User.Following")}</i>
							</div>
						</div>
						<div className={styles.oragzation}>
							<span>{intl.get("Register.Organization")}：</span>
							<i>{baseInfo.organization}</i>
							{baseInfo.email && <React.Fragment>
								<span>{intl.get("Email")}：</span>
								<span>{baseInfo.email}</span>
							</React.Fragment>
							}
						</div>
						<div className={styles.desBox}>{intl.get("User.Biography")}：{baseInfo.signature || intl.get("User.No signature yet")}</div>
					</div>
				</div>
				{
					uuid !== pUuid &&
					<div>
						{
							isFollow ?
								<Button type="primary" onClick={handelFollow}>{intl.get("User.Unfollow")}</Button>
								:
								<Button type="primary" onClick={handelFollow} icon={<HeartFilled style={{ color: '#fff' }} />}>{intl.get("User.Follow")}</Button>
						}
					</div>
				}
			</div>

			<Spin spinning={loading}>
				<div className={styles.resourceBox}>
					<Tabs
						onChange={(e) => {
							setparams({
								...params,
								currentPage: 1,
							})
							setTabKey(e)
						}}
						centered
						size="large"
						tabBarGutter={150}
						className={styles.tabBox}
						items={items.map(item => {
							return {
								label: <span style={{ fontSize: "20px" }}>{item.label.toUpperCase()}</span>,
								key: item.key,
								children: item.children
							}
						})}
						indicator={{
							size: 150,
						}}>
					</Tabs>

					{(tabKey === "1" || tabKey === "2") && <div>
						<div className={classNames(styles.sortBox, "flex_box align_center")}>
							{
								sorts.map(item => {
									return <div key={item.value} onClick={() => changeSort(item.value)} className={classNames(item.value === sortBy && styles.activeBox, "flex_box align_center")}>
										<span>{item.title}</span>
										<SVG
											height={14}
											src={`${process.env.PUBLIC_URL}/svg/order.svg`}
										></SVG>
									</div>
								})
							}
						</div>
						{
							dataSource.length > 0 ?
								<Masonry
									columns={2}
									gutter={30}
									items={dataSource.map(data => ({
										key: data.resourceUuid,
										data: data,
									}))}
									itemRender={({ data }) => <ResourceCard
										isShowContributor={tabKey === "2" ? true : false}
										isShowView={true}
										data={data}
										rows={5}
										changeData={updateData}
									/>}
								/>
								: <NoData />
						}

					</div>}
					{
						total > 0 && <Pagination
							style={{ marginTop: "20px" }}
							align="end"
							current={params.currentPage}
							pageSize={params.pageSize}
							total={total}
							showSizeChanger={false}
							onChange={(page, pageSize) => {
								setparams({
									currentPage: page,
									pageSize: pageSize,
								});
							}}
						/>
					}
				</div>
			</Spin>
		</div>
	</div>
}
export default User;